/* Built In Imports */
import NextLink from 'next/link';

/* External Imports */
import { ChevronDownIcon } from '@chakra-ui/icons';
import {
  Box,
  Flex,
  Link,
  Menu,
  MenuButton,
  MenuItem,
  MenuList
} from '@chakra-ui/react';
import { nanoid } from 'nanoid';

/* Internal Imports */
/* Components */
import config from '@config';

/* Services */

/**
 * Renders the SecNav component
 *
 * @param {string} page page name
 * @param {string} alsoin languages
 * @param {string} region country
 * @param {string} lang language
 * @returns {ReactElement} Breadcrum component
 */

const SecNav = ({ page, alsoin, url, region, lang, pageConfig, secNav }) => {

  return <>
    <Box
      zIndex="6"
      display="flex"
      fontFamily="Fedra-Light"
      fontSize="13px"
      letterSpacing=".2px"
      color="rgb(0 0 0)"
      pos="relative"
      w="100%"
      maxW="1300px"
      background="#F4F4F4"
      height={{ base: "53px", md: "61px" }}
      // maxHeight="40px"
      // overflow="hidden"
      justifyContent="flex-end"
      p={{
        base: '9px 15px',
        sm: '9px 15px',
        lg: '9px calc((100% - 1134px) / 2) 9px calc((100% - 1134px) / 2)',
      }}
      m="0 auto"
      //  justifyContent="right"
    >
      <Flex>
        <Box
          as="span"
          display={{ base: "none", md: "block" }}
          fontFamily="FedraSansStd-book, sans-serif"
          fontSize={{ base: '13px', md: '16px' }}
          letterSpacing="0.2px"
          color="#1D1D1D"
          position="relative"
          mr="0"
          mt="5px"
        >
          Find Books In:
        </Box>
        <Box
          as="span"
          display="inline-flex"
        >
          <Menu>
            <MenuButton
              color={{ base: "000", md: "#cf4520" }}
              ml="12px"
              p={{ base: '6px 12px', lg: '6px 12px' }}
              fontSize='16px'
              border={{ base: 'none', md: '1px solid #D04723' }}
              h="34px"
              borderRadius='4px'
            >
              {config.lngListTrans[lang]} <ChevronDownIcon fontSize="15px" color="#cf4520" />
            </MenuButton>
            <MenuList
              color="#cf4520"
              w="100px"
              minW="100px"
              border="0"
              key={nanoid()}
            >
              {alsoin?.map((n, i) => {
                return i >= 0 && (
                  <NextLink href={n.url} passHref prefetch={false} legacyBehavior>
                    <Link>
                      <MenuItem
                        w="100px"
                        bgColor="transparent"
                        _focus={{ bgColor: 'trasparent' }}
                        _hover={{ bgColor: '#e4ded4' }}
                      >
                        <Box
                          key={i}
                          color="#cf4520"
                          fontSize={{ base: '12px', lg: '13px' }}
                          _hover={{ textDecoration: 'none' }}
                          cursor="pointer"
                        >
                          {n.title}
                        </Box>
                      </MenuItem>
                    </Link>
                  </NextLink>
                );
              })}
            </MenuList>
          </Menu>
        </Box>
      </Flex>
    </Box>
  </>;
};

export default SecNav;